import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useStore from "../store/useStore";

import FormHubSpot from "./FormHubSpot";

export default function GetInTuch() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  const video =
    "https://api.institucional.global.sidom.io/uploads/Dots_Background_04_1_9e4411c72c.mp4";
  const setVideoUrlError = useStore((state) => state.setVideoUrlError);

  return (
    <>
      <div className="relative border border-sidom-blue   ">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          autoPlay
          loop
          muted
          onError={() => {
            setVideoUrlError("No se pudo cargar el video");
          }}
        >
          <source src={video} type="video/mp4" />
        </video>
        <div
          data-aos="fade-up"
          data-aos-delay="900"
          className="  container mt-[100px]  mb-[100px] flex flex-col justify-center items-center text-left "
        >
          <h2 className=" text-4xl text-sidom-orange md:text-5xl font-extrabold mb-[60px] text-left ">
            Contáctese con nosotros
          </h2>
          <div className="w-full md:w-[600px] lg:w-[800px] xl:w-[1000px] 2xl:w-[1200px]">
            <FormHubSpot />
          </div>
        </div>
      </div>
    </>
  );
}
